import axios from 'axios';
import generateToken from '../../modulos/tokens/generateToken';
import interceptorRequestAxios from '../interceptors/request-axios';
import { interceptorResponseAxios, interceptorResponseErrorAxios } from '../interceptors/response-axios';
import logout  from '../../modulos/function/logout.jsx';
import { extrairDadosToken } from '../../modulos/auth/extrairDadosToken';
import { retornoHashValor } from '../../modulos/cripotografia/hash.js';

const url = retornoHashValor(process.env.REACT_APP_1);
const THOUSAND_SECONDS = 1000;
const TWO_MINUTES = 2;
const apiZelo = axios.create({
    baseURL: url,
    headers: {
        'Content-Type': 'application/json'
    }
});

if (process.env.REACT_APP_ENV === 'prod') {
    apiZelo.interceptors.request.use(interceptorRequestAxios);
    apiZelo.interceptors.response.use(interceptorResponseAxios, interceptorResponseErrorAxios);
}

const isAccessTokenExpired = () => {
    const token = localStorage.getItem('token');
    const { exp } = extrairDadosToken(token);
    const expMilliseconds = exp * THOUSAND_SECONDS;
    const expirationDate = new Date(expMilliseconds);

    expirationDate.setMinutes(expirationDate.getMinutes() - TWO_MINUTES);
    
    if (expirationDate) {
        const now = new Date();

        return expirationDate <now;
    } else {
        logout();
    }
  
    return false;
};

const updateToken = async () => {
    try {
        const refreshToken = localStorage.getItem('refresh_token');

        await generateToken.refreshToken(refreshToken);
    } catch (error) {
        console.log(error);
        logout();
    }
};

apiZelo.interceptors.request.use(async config => {
    if (isAccessTokenExpired ()) {
        await updateToken();
    }
    
    const token = localStorage.getItem('token');

    config.headers['x-auth-token'] = token;

    return config;
});

export default apiZelo;